// extracted by mini-css-extract-plugin
module.exports = {"fixed_bottom":"DfsButton_fixed_bottom__1GQXE","fixed_loader":"DfsButton_fixed_loader__1EDjK","height_full":"DfsButton_height_full__1f3p9"};